var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vimeo from "../Vimeo";
var Syncer = /** @class */ (function () {
    function Syncer(sanity) {
        var _this = this;
        this.getVideoAssetMap = function () { return __awaiter(_this, void 0, void 0, function () {
            var videosAllreadySynced, res, _i, videosAllreadySynced_1, video;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sanity.getAllVimeoAssets()];
                    case 1:
                        videosAllreadySynced = _a.sent();
                        res = {};
                        for (_i = 0, videosAllreadySynced_1 = videosAllreadySynced; _i < videosAllreadySynced_1.length; _i++) {
                            video = videosAllreadySynced_1[_i];
                            res[video.resource_key] = video;
                        }
                        return [2 /*return*/, res];
                }
            });
        }); };
        this.syncVideo = function (videoToSync) {
            console.log("Syncing video with id " + videoToSync.resource_key);
            return _this.sanity.createOrUpdateVimeoAsset(videoToSync);
        };
        this.checkIfVideoHasBeenModified = function (videoToSync, videoAllreadySynced) { return videoAllreadySynced.modified_unix_time < videoToSync.modified_unix_time; };
        this.syncOrSkipVideo = function (videoToSync, videoAllreadySynced) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!videoAllreadySynced)
                    return [2 /*return*/, this.syncVideo(videoToSync)];
                if (this.checkIfVideoHasBeenModified(videoToSync, videoAllreadySynced))
                    return [2 /*return*/, this.syncVideo(videoToSync)];
                return [2 /*return*/, console.log("Skipping video with id " + videoToSync.resource_key)];
            });
        }); };
        this.deleteVideo = function (videoIdToDelete) {
            console.log("Deleting video with id " + videoIdToDelete);
            return _this.sanity.deleteVimeoAsset(videoIdToDelete);
        };
        this.deleteVideos = function (videosAllreadySynced, videosToKeep) {
            var promises = [];
            for (var _i = 0, _a = Object.keys(videosAllreadySynced); _i < _a.length; _i++) {
                var videoId = _a[_i];
                var shouldKeepVideo = videosToKeep[videoId];
                if (shouldKeepVideo)
                    continue;
                promises.push(_this.deleteVideo(videoId));
            }
            return Promise.all(promises);
        };
        this.syncAllVideosWithSanity = function () { return __awaiter(_this, void 0, void 0, function () {
            var videosAllreadySynced, videosToKeep, nextResponse, promises, videos, _i, videos_1, video;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVideoAssetMap()];
                    case 1:
                        videosAllreadySynced = _a.sent();
                        videosToKeep = {};
                        return [4 /*yield*/, Vimeo.allVideos.getFirst()];
                    case 2:
                        nextResponse = _a.sent();
                        promises = [];
                        _a.label = 3;
                    case 3:
                        if (!(nextResponse && nextResponse.data)) return [3 /*break*/, 5];
                        videos = nextResponse.data;
                        for (_i = 0, videos_1 = videos; _i < videos_1.length; _i++) {
                            video = videos_1[_i];
                            if (!video.resource_key) {
                                console.error("Video with title: " + video.name + " didn't have an id. We can therefore not process it at this time");
                                continue;
                            }
                            videosToKeep[video.resource_key] = video.resource_key;
                            promises.push(this.syncOrSkipVideo(video, videosAllreadySynced[video.resource_key]));
                        }
                        videos = [];
                        return [4 /*yield*/, Vimeo.allVideos.getNext()];
                    case 4:
                        nextResponse = _a.sent();
                        return [3 /*break*/, 3];
                    case 5: return [4 /*yield*/, Promise.all(promises)];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.deleteVideos(videosAllreadySynced, videosToKeep)];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.sanity = sanity;
    }
    return Syncer;
}());
export { Syncer };
